// extracted by mini-css-extract-plugin
module.exports = {"container":"container___2YmSa","head":"head___3E04K","subTitle":"subTitle___12MV8","body":"body___80j0E"};